import { Link } from "react-router-dom";

/**
 * Fixed availability badge shown on larger screens.
 * Translation: Fixed availability badge shown on larger screens.
 *
 * @param {{label: string}} props - Badge props.
 * @returns {JSX.Element} Floating badge.
 */
const FloatingBadge = ({ label }) => (
  <Link
    to="/#contact"
    className="floating-badge"
    aria-label={`Contact us regarding ${label.toLowerCase()}`}
    title={`Inquire about our availability: ${label}`}
  >
    <div className="writing-mode-vertical rotate-180">
      <span>{label}</span>
    </div>
  </Link>
);

export default FloatingBadge;
